// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { MediaFieldsets, type SearchFormValue } from './SearchForm';
import { mediaUgcType } from './SearchForm/config/fields.config';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const { name: UGCTYPENAME } = mediaUgcType;

const label = 'Images & Video';
const MediaSearch = (props: *) => {
  const clientProps = useContext(ClientContext);
  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      '/images-and-video',
      '/media-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  const patchUgcType = (val: SearchFormValue) =>
    !val.get(UGCTYPENAME) ? val.set(UGCTYPENAME, 'Image Video') : val;

  return (
    <SearchView
      label={label}
      primaryFieldsets={MediaFieldsets.primaryFieldsets}
      extraFieldsets={MediaFieldsets.extraFieldsets}
      onSubmit={patchUgcType}
      {...props}
    />
  );
};

MediaSearch.label = label;

export default MediaSearch;



// WEBPACK FOOTER //
// ./src/containers/search/Media.js